/**
 * FML coverage skeleton
 */

import {
  BaseBenefitPlanPolicyPeriod,
  RfpCoverage,
  CoverageTypeEnum,
  BenefitPlanTypeEnum,
  PlanOptionNameEnum,
  FundingTypeEnum,
  RfpBenefitPlan,
} from "../../types/rfp.api.types";

export const getFmlSkeleton = (): Partial<RfpCoverage> => ({
  type: CoverageTypeEnum.FMLA,
  status: "quoted",
  notes: "",
  benefitPlans: [
    {
      identifier: "fml-plan-1",
      name: "FML Plan",
      numberOfLives: 0,
      type: BenefitPlanTypeEnum.NOT_APPLICABLE,
      policyPeriod: BaseBenefitPlanPolicyPeriod.current,
      currentCarrierName: "",
      fundingType: FundingTypeEnum.FULLY_INSURED,
      participationRequirements: "",
      rateGuarantee: undefined,
      rateCap: "",
      optionName: PlanOptionNameEnum.NOT_APPLICABLE,
      benefitClassAvailability: [],
      rateSchedule: [],
      benefits: {
        objectType: "fml",

        // Federal FMLA
        federalFmlaType: "notIncluded",
        federalFmlaAmount: 1,

        // Unpaid State Leaves
        unpaidStateLeavesType: "notIncluded",
        unpaidStateLeavesAmount: 1,

        // Military (USERRA)
        militaryUserraType: "notIncluded",
        militaryUserraAmount: 1,

        // Jury Duty
        juryDutyType: "notIncluded",
        juryDutyAmount: 1,

        // ADA
        adaType: "notIncluded",
        adaAmount: 1,

        // Integrated STD/FMLA Claim Intake
        integratedStdFmlaClaimIntake: undefined,

        // Text fields
        historyAndTakeover: "",
        companyLeaves: "",
        correspondence: "",
      },
    } as RfpBenefitPlan,
  ],
});
